<template>
    <i-switch :disabled="disabled" @on-change="change" v-model="value">
        <span slot="open">是</span>
        <span slot="close">否</span>
    </i-switch>
</template>
<script>
export default {
    props: {
        data: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    model: {
        prop: 'data',
        event: 'cValue'
    },
    data() {
        return {
            value: true,
            model: 0//0--数字0-1 1--字符串 是-否
        }

    },
    methods: {
        ff() {

            
            if (typeof this.data == 'string') {
                this.model = 1;
            }
            if (typeof this.data == 'number') {
                this.model = 0;
            }
            if (this.data === 0) {
                this.value = false;

            }
            if (this.data == '否') {
                this.value = false;

            }
            if (this.data == '') {
                this.value = false;

            }
            if (this.data === 1) {
                this.value = true;

            }
            if (this.data == '是') {
                this.value = true;

            }
        },
        change(v) {
            //let t = v ? 1 : 0;
            let t;
            if (v == false) {

                if (this.model == 0) {
                    t = 0;
                } else {
                    t = '否'
                }
            }
            if (v == true) {
                if (this.model == 0) {
                    t = 1;
                } else {
                    t = '是'
                }
            }
            this.$emit('cValue', t)
        }
    },
    mounted() {
        this.ff();
    },
    watch: {
        data() {
            this.ff();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/iSwitchLy.vue